(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorico-presale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      var sidebar = document.getElementById('doricoPresaleFilters');
      if (!sidebar) return;

      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-filter-card]'));
      var langGroups = Array.prototype.slice.call(document.querySelectorAll('[data-filter-lang-group]'));
      var gameSections = Array.prototype.slice.call(document.querySelectorAll('[data-filter-game-section]'));
      var emptyState = document.getElementById('doricoPresaleFilteredEmpty');
      var gameChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-game]'));
      var langChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-lang]'));
      var availChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-available]'));
      var slider = sidebar.querySelector('[data-filter-price-slider]');
      var minInput = slider ? slider.querySelector('[data-filter-price-min]') : null;
      var maxInput = slider ? slider.querySelector('[data-filter-price-max]') : null;
      var rangeFill = slider ? slider.querySelector('[data-filter-price-range]') : null;
      var minLabel = sidebar.querySelector('[data-filter-price-min-label]');
      var maxLabel = sidebar.querySelector('[data-filter-price-max-label]');
      var resetBtn = sidebar.querySelector('[data-filter-reset]');
      var sliderMax = minInput ? parseFloat(minInput.max) : 0;

      function selected(list) {
        return list.filter(function (cb) { return cb.checked; }).map(function (cb) { return cb.value; });
      }

      function updatePriceUI() {
        if (!minInput || !maxInput) return { min: 0, max: Infinity };
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);
        if (minVal > maxVal) {
          minVal = maxVal;
          minInput.value = minVal;
        }
        var minPct = sliderMax ? (minVal / sliderMax) * 100 : 0;
        var maxPct = sliderMax ? (maxVal / sliderMax) * 100 : 100;
        if (rangeFill) {
          rangeFill.style.left = minPct + '%';
          rangeFill.style.width = Math.max(0, maxPct - minPct) + '%';
        }
        minInput.style.zIndex = minVal > sliderMax / 2 ? 5 : 3;
        maxInput.style.zIndex = minVal > sliderMax / 2 ? 3 : 5;
        if (minLabel) minLabel.textContent = '€' + minVal;
        if (maxLabel) maxLabel.textContent = '€' + maxVal;
        return { min: minVal * 100, max: maxVal * 100 };
      }

      function applyFilters() {
        var games = selected(gameChecks);
        var langs = selected(langChecks);
        var avail = selected(availChecks);
        var priceRange = updatePriceUI();
        var anyVisible = false;

        cards.forEach(function (card) {
          var g = card.getAttribute('data-game');
          var l = card.getAttribute('data-lang');
          var a = card.getAttribute('data-available');
          var p = parseFloat(card.getAttribute('data-price')) || 0;
          var visible = games.indexOf(g) !== -1 && langs.indexOf(l) !== -1;
          if (visible && a !== null && avail.indexOf(a) === -1) visible = false;
          if (visible && p < priceRange.min) visible = false;
          if (visible && p > priceRange.max) visible = false;
          card.style.display = visible ? '' : 'none';
          if (visible) anyVisible = true;
        });

        langGroups.forEach(function (group) {
          var hasVisible = Array.prototype.slice.call(group.querySelectorAll('[data-filter-card]')).some(function (c) {
            return c.style.display !== 'none';
          });
          group.style.display = hasVisible ? '' : 'none';
        });

        gameSections.forEach(function (section) {
          var hasVisible = Array.prototype.slice.call(section.querySelectorAll('[data-filter-lang-group]')).some(function (gr) {
            return gr.style.display !== 'none';
          });
          section.style.display = hasVisible ? '' : 'none';
        });

        if (emptyState) emptyState.style.display = anyVisible ? 'none' : '';
      }

      gameChecks.forEach(function (cb) { cb.addEventListener('change', applyFilters); });
      langChecks.forEach(function (cb) { cb.addEventListener('change', applyFilters); });
      availChecks.forEach(function (cb) { cb.addEventListener('change', applyFilters); });
      if (minInput) minInput.addEventListener('input', applyFilters);
      if (maxInput) maxInput.addEventListener('input', applyFilters);
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          gameChecks.forEach(function (cb) { cb.checked = true; });
          langChecks.forEach(function (cb) { cb.checked = true; });
          availChecks.forEach(function (cb) { cb.checked = true; });
          if (minInput) minInput.value = minInput.min;
          if (maxInput) maxInput.value = maxInput.max;
          applyFilters();
        });
      }

      applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dorico-ready-stock"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      var sidebar = document.getElementById('doricoReadyFilters');
      if (!sidebar) return;

      var cards = Array.prototype.slice.call(document.querySelectorAll('[data-filter-card]'));
      var emptyState = document.getElementById('doricoReadyFilteredEmpty');
      var gameChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-game]'));
      var langChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-lang]'));
      var availChecks = Array.prototype.slice.call(sidebar.querySelectorAll('[data-filter-available]'));
      var slider = sidebar.querySelector('[data-filter-price-slider]');
      var minInput = slider ? slider.querySelector('[data-filter-price-min]') : null;
      var maxInput = slider ? slider.querySelector('[data-filter-price-max]') : null;
      var rangeFill = slider ? slider.querySelector('[data-filter-price-range]') : null;
      var minLabel = sidebar.querySelector('[data-filter-price-min-label]');
      var maxLabel = sidebar.querySelector('[data-filter-price-max-label]');
      var resetBtn = sidebar.querySelector('[data-filter-reset]');
      var sliderMax = minInput ? parseFloat(minInput.max) : 0;

      function activeValues(list) {
        return list.filter(function (el) { return el.checked; }).map(function (el) { return el.value; });
      }

      function updatePriceUI() {
        if (!minInput || !maxInput) return { min: 0, max: Infinity };
        var minVal = parseFloat(minInput.value);
        var maxVal = parseFloat(maxInput.value);
        if (minVal > maxVal) {
          minVal = maxVal;
          minInput.value = minVal;
        }
        var minPct = sliderMax ? (minVal / sliderMax) * 100 : 0;
        var maxPct = sliderMax ? (maxVal / sliderMax) * 100 : 100;
        if (rangeFill) {
          rangeFill.style.left = minPct + '%';
          rangeFill.style.width = Math.max(0, maxPct - minPct) + '%';
        }
        minInput.style.zIndex = minVal > sliderMax / 2 ? 5 : 3;
        maxInput.style.zIndex = minVal > sliderMax / 2 ? 3 : 5;
        if (minLabel) minLabel.textContent = '€' + minVal;
        if (maxLabel) maxLabel.textContent = '€' + maxVal;
        return { min: minVal * 100, max: maxVal * 100 };
      }

      function applyFilters() {
        var activeGames = activeValues(gameChecks);
        var activeLangs = activeValues(langChecks);
        var activeAvail = activeValues(availChecks);
        var priceRange = updatePriceUI();
        var anyVisible = false;

        cards.forEach(function (card) {
          var g = card.getAttribute('data-game');
          var l = card.getAttribute('data-lang');
          var a = card.getAttribute('data-available');
          var price = parseFloat(card.getAttribute('data-price')) || 0;
          var visible = true;

          if (g && activeGames.indexOf(g) === -1) visible = false;
          if (l && activeLangs.indexOf(l) === -1) visible = false;
          if (a !== null && activeAvail.indexOf(a) === -1) visible = false;
          if (price < priceRange.min) visible = false;
          if (price > priceRange.max) visible = false;

          card.style.display = visible ? '' : 'none';
          if (visible) anyVisible = true;
        });

        if (emptyState) {
          emptyState.style.display = (!anyVisible && cards.length > 0) ? '' : 'none';
        }
      }

      gameChecks.forEach(function (el) { el.addEventListener('change', applyFilters); });
      langChecks.forEach(function (el) { el.addEventListener('change', applyFilters); });
      availChecks.forEach(function (el) { el.addEventListener('change', applyFilters); });
      if (minInput) minInput.addEventListener('input', applyFilters);
      if (maxInput) maxInput.addEventListener('input', applyFilters);
      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          gameChecks.forEach(function (el) { el.checked = true; });
          langChecks.forEach(function (el) { el.checked = true; });
          availChecks.forEach(function (el) { el.checked = true; });
          if (minInput) minInput.value = minInput.min;
          if (maxInput) maxInput.value = maxInput.max;
          applyFilters();
        });
      }

      applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
